import React from "react";
import User from "services/User";
import appConfig from "utils/appConfig";

const {
    bloombergSiteUrl,
    settingsInactivityTimeout
} = appConfig();

class WithInactivityTimeout extends React.Component {
    constructor(props) {
        super(props);

        this._resetTimer = this._resetTimer.bind(this);
        this._cleanupTimer = this._cleanupTimer.bind(this);
    }

    _resetTimer() {
        if (this._inactivityTimeout) {
            clearTimeout(this._inactivityTimeout);
        }

        this._inactivityTimeout = setTimeout(this._logout.bind(this), settingsInactivityTimeout);
    }

    componentDidMount() {
        if (!settingsInactivityTimeout) {
            return;
        }

        document.addEventListener("mousemove", this._resetTimer);
        document.addEventListener("mousedown", this._resetTimer);
        document.addEventListener("keypress", this._resetTimer);
        document.addEventListener("touchmove", this._resetTimer);
    }

    _cleanupTimer() {
        if (!settingsInactivityTimeout) {
            return;
        }

        document.removeEventListener("mousemove", this._resetTimer);
        document.removeEventListener("mousedown", this._resetTimer);
        document.removeEventListener("keypress", this._resetTimer);
        document.removeEventListener("touchmove", this._resetTimer);
        clearTimeout(this._inactivityTimeout);
    }

    _logout() {
        this._cleanupTimer();
        User.logout(bloombergSiteUrl);
    }

    render() {
        return <div>{ this.props.children }</div>;
    }
}

export default (Component) => (props) => {
    return (
        <WithInactivityTimeout>
            <Component { ...props } />
        </WithInactivityTimeout>
    );
};
